import { useEffect, useState } from "react";
import { X, CheckCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface CartNotificationProps {
  isVisible: boolean;
  onClose: () => void;
  itemName: string;
  quantity: number;
}

export function CartNotification({
  isVisible,
  onClose,
  itemName,
  quantity,
}: CartNotificationProps) {
  const [isAnimating, setIsAnimating] = useState(false);
  const navigate = useNavigate();

  const handleClickNotification = () => {
    onClose(); // close the toast
    navigate("/checkout"); // go to checkout
  };
  useEffect(() => {
    if (isVisible) {
      setIsAnimating(true);

      const timer = setTimeout(() => {
        onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div
      className="fixed top-4 right-4 z-50 animate-slide-in-right cursor-pointer"
      onClick={handleClickNotification}
    >
      <Card className="w-80 shadow-xl border-2 border-emerald-200 bg-emerald-50 animate-bounce-gentle">
        <CardContent className="p-4">
          <div className="flex items-start space-x-3">
            {/* Icon */}
            <div className="w-10 h-10 bg-emerald-500 rounded-full flex items-center justify-center animate-pulse-slow">
              <CheckCircle className="w-5 h-5 text-white" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <h4 className="font-bold text-sm text-emerald-800">
                  Item Added to Cart!
                </h4>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation(); // ⛔ prevents navigation
                    onClose();
                  }}
                  className="h-6 w-6 p-0 text-gray-400 hover:text-gray-600"
                >
                  <X className="w-4 h-4" />
                </Button>
              </div>

              <p className="text-xs text-emerald-800 mb-1">
                {quantity}× {itemName} added to your cart.
              </p>

              <p className="text-xs text-emerald-600">
                You can view it in your cart.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
